
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4DzVW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f98839aa6331f989febbeba007e97e95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3606ad94ea15a357$var$_react = $3606ad94ea15a357$var$_interopRequireDefault((parcelRequire("42omo")));

var $3606ad94ea15a357$var$_baseNew = $3606ad94ea15a357$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3606ad94ea15a357$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartPie".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Pie and segment charts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3606ad94ea15a357$var$ChartPieIcon = (props)=>/*#__PURE__*/ $3606ad94ea15a357$var$_react.default.createElement($3606ad94ea15a357$var$_baseNew.default, Object.assign({
        name: "ChartPieIcon",
        dangerouslySetGlyph: `<mask id="mask0_67704_26611" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="currentcolor" d="M5.106 0C5.04.239 5 .49 5 .75v7.5a2.75 2.75 0 0 0 3.462 2.656l7.246-1.941q.15-.04.292-.098V16H0V0zm5.672 4.59-.278.076v-.29q.143.102.278.215M16 2.17A10.3 10.3 0 0 0 13.831 0H16z"/></mask><g mask="url(#mask0_67704_26611)"><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8a6.25 6.25 0 1 0 12.5 0 6.25 6.25 0 0 0-12.5 0Z"/></g><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 8.25V.75c3.47 0 6.39 2.357 7.246 5.558z"/>`
    }, props));
$3606ad94ea15a357$var$ChartPieIcon.displayName = 'ChartPieIcon';
var $3606ad94ea15a357$var$_default = module.exports.default = $3606ad94ea15a357$var$ChartPieIcon;

});


//# sourceMappingURL=chart-pie.9ed584e4.js.map
